import React, {useEffect, useRef, useState} from 'react';
import {Calendar} from 'react-date-range';
import './CreateCustomCampaign.css';
import {useFormValidation} from '../../../../../hooks/useFormValidation/useFormValidation';
import CampaignsPreviewPhone from "../../CampaignsPreviewPhone/CampaignsPreviewPhone";
import Moment from "moment";
import AccountLimitReached from "../../../../Modal/AccounLimitReached/AccountLimitReached";
import Message from "../../../../Modal/Message/Message";
import Spinner from 'react-bootstrap/Spinner';


const MESSAGES = {
    noUserTargeted: 'You are targeting on wrong way. Change conditions and try again.',
    noImage: 'Image missing',
    noCarouselItems: 'At least one carousel item is required'
};

const INPUT_DATE_NAME = {
    VALID_FROM: 'validFrom',
    VALID_TO: 'validTo',
};

const CAMPAIGN_MODE = {
    SINGLE_IMAGE: 'singleImage',
    CAROUSEL: 'carousel'
};

const INITIAL_STATE = {
    campaignType: '',
    voucherType: '',
    offerValue: '',
    image: '',
    validFrom: '',
    validTo: '',
    campaignsList: [],
    usedOnlyOnce: true,
    campaignMode: CAMPAIGN_MODE.SINGLE_IMAGE,
    carouselItems: []
};

const CreateCustomCampaign = (props) => {
    const {handleCampaignData, handleModalData, closeModal, companyData, visits, newCampaignsListUid, companyLogoURL, loading} = props;
    const [resetFileInputValue, setResetFileInputValue] = useState('');
    const [countOfIds, setCountOfIds] = useState(0);
    const [carouselItems, setCarouselItems] = useState([]);
    const [currentCarouselItem, setCurrentCarouselItem] = useState({ image: null, buttonText: '', buttonLink: '' });
    const formRef = useRef();

    const passCampaignDataToParent = () => {
        const maximumNumberOfMessagesCompanyCanSend = companyData.accountBalance / companyData.messagePrice;
        const isCarouselMode = values.campaignMode === CAMPAIGN_MODE.CAROUSEL;

        if (isCarouselMode) {
            if (carouselItems.length < 1) {
                const modalComponent = <Message message={MESSAGES.noCarouselItems}/>;
                handleModalData(modalComponent);
                return;
            }
        } else {
            if (!values.image) {
                const modalComponent = <Message message={MESSAGES.noImage}/>;
                handleModalData(modalComponent);
                return;
            }
        }

        if (countOfIds < 1) {
            const modalComponent = <Message message={MESSAGES.noUserTargeted}/>;
            handleModalData(modalComponent);
            return
        }
        if (countOfIds > maximumNumberOfMessagesCompanyCanSend) {
            const modalComponent = <AccountLimitReached
                numberOfUserToTarget={countOfIds}
                maximumNumberOfMessagesCompanyCanSend={maximumNumberOfMessagesCompanyCanSend}
                closeModal={closeModal}/>;

            handleModalData(modalComponent);
        } else {
            const newCampaignsObject = {
                campaignType: values.campaignType,
                voucherType: values.voucherType,
                companyUid: companyData.uid,
                offerValue: values.offerValue,
                image: isCarouselMode ? null : values.image,
                carouselItems: isCarouselMode ? carouselItems : [],
                usedOnlyOnce: values.usedOnlyOnce,
                validFrom: values.validFrom ? values.validFrom.getTime() : 0,
                validTo: values.validTo ? values.validTo.getTime() : 0,
                campaignsList: values.campaignsList.length ? values.campaignsList.toString().split(",").map(userUid => {
                    return {uid: userUid.trim()}
                }) : [],
            };
            handleCampaignData(newCampaignsObject);
            resetForm(INITIAL_STATE);
            setCarouselItems([]);
            setCurrentCarouselItem({ image: null, buttonText: '', buttonLink: '' });
            formRef.current.reset();
        }
    };

    const {handleChange, handleSubmit, handleBlur, resetForm, errors, isSubmitting, values} = useFormValidation(INITIAL_STATE, passCampaignDataToParent);

    useEffect(() => {
        const event = {
            target: {
                name: 'campaignsList',
                value: newCampaignsListUid,
            }
        };
        if (newCampaignsListUid.length) {
            setCountOfIds(newCampaignsListUid.length);
            handleChange(event);
            handleBlur();
        }
    }, []);

    useEffect(() => {
        const count = values.campaignsList ? values.campaignsList.toString().split(',').filter(e =>  e).length : 0;
        setCountOfIds(count)
    }, [values]);


    const handleSelectedDateValidFrom = (date) => {
        const event = {
            target: {
                name: INPUT_DATE_NAME.VALID_FROM,
                value: date,
            }
        };
        handleChange(event);
        handleBlur();
    };
    const handleSelectedDateValidTo = (date) => {
        const event = {
            target: {
                name: INPUT_DATE_NAME.VALID_TO,
                value: date,
            }
        };
        handleChange(event);
        handleBlur();
    };

    const handleDateDismiss = (inputDateName) => {
        const event = {
            target: {
                name: inputDateName,
                value: '',
            }
        };
        handleChange(event);
    };


    const resetsTheFileInput = () => {
        let randomString = Math.random().toString(36);
        setResetFileInputValue(randomString);
        const event = {
            target: {
                name: 'image',
                value: null,
            }
        };
        handleChange(event)
    };

    const handleCarouselItemChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'carouselImage' && files && files[0]) {
            setCurrentCarouselItem(prev => ({ ...prev, image: files[0] }));
        } else {
            setCurrentCarouselItem(prev => ({ ...prev, [name]: value }));
        }
    };

    const addCarouselItem = () => {
        if (currentCarouselItem.image) {
            setCarouselItems(prev => [...prev, { ...currentCarouselItem, id: Date.now() }]);
            setCurrentCarouselItem({ image: null, buttonText: '', buttonLink: '' });
        }
    };

    const removeCarouselItem = (id) => {
        setCarouselItems(prev => prev.filter(item => item.id !== id));
    };

    const handleCampaignModeChange = (mode) => {
        const event = {
            target: {
                name: 'campaignMode',
                value: mode,
            }
        };
        handleChange(event);
    };

    return (
        <div className='campaign-container'>
            <div className='campaign-wrapper'>
                <div className='campaign-form-wrapper'>
                    <form ref={formRef} className='campaign-form' onSubmit={handleSubmit}>
                        <div className='campaign-account-balance-wrapper'>
                            <p className='campaign-account-balance'>Stanje na računu
                                : {companyData.accountBalance} RSD</p>
                        </div>
                        <div className='campaign-form-section'>
                            <p className={'error-message'}>{errors.campaignType}</p>
                            <label className='campaign-form-label' htmlFor="">Campaign type:</label>
                            <input
                                className={`campaign-form-input ${errors.campaignType && 'error-input'}`}
                                name='campaignType'
                                placeholder='Campaign type'
                                autoComplete='off'
                                value={values.campaignType}
                                onBlur={handleBlur}
                                onChange={handleChange}/>
                        </div>
                        <div className='campaign-form-section'>
                            <p className={'error-message'}>{errors.voucherType}</p>
                            <label className='campaign-form-label' htmlFor="">Voucher type:</label>
                            <input
                                className={`campaign-form-input ${errors.voucherType && 'error-input'}`}
                                name='voucherType'
                                placeholder='Voucher type'
                                autoComplete='off'
                                value={values.voucherType}
                                onBlur={handleBlur}
                                onChange={handleChange}/>
                        </div>
                        <div className='campaign-form-section'>
                            <label className='campaign-form-label' htmlFor="">Offer:</label><br/>
                            <label className='campaign-form-label important-good-message' htmlFor="">Here <b>&#123;0&#125;</b> will be replaced with UID</label>
                            <br/><label className={'error-message'}>{errors.offerValue}</label>
                            <textarea className={`campaign-form-textarea ${errors.offerValue && 'error-input'}`}
                                      name='offerValue'
                                      value={values.offerValue}
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      cols="60"
                                      rows="3"/>

                        </div>
                        <div className='campaign-form-section'>
                            <label className='campaign-form-label'>Campaign Image Mode:</label>
                            <div className='campaign-mode-toggle'>
                                <button
                                    type='button'
                                    className={`campaign-mode-btn ${values.campaignMode === CAMPAIGN_MODE.SINGLE_IMAGE ? 'active' : ''}`}
                                    onClick={() => handleCampaignModeChange(CAMPAIGN_MODE.SINGLE_IMAGE)}
                                >
                                    Single Image
                                </button>
                                <button
                                    type='button'
                                    className={`campaign-mode-btn ${values.campaignMode === CAMPAIGN_MODE.CAROUSEL ? 'active' : ''}`}
                                    onClick={() => handleCampaignModeChange(CAMPAIGN_MODE.CAROUSEL)}
                                >
                                    Carousel
                                </button>
                            </div>
                        </div>

                        {values.campaignMode === CAMPAIGN_MODE.SINGLE_IMAGE && (
                            <div className='campaign-form-section'>
                                <label className='campaign-form-label'>Photo:</label>
                                <button type='button' className='campaign-form-remove-selected-image' onClick={resetsTheFileInput}>X
                                </button>
                                <input className={`campaign-form-input ${errors.image && 'error-input'}`}
                                       name='image'
                                       type="file"
                                       id='image-file'
                                       key={resetFileInputValue}
                                       accept="image/jpg ,image/jpeg, image/png, .json"
                                       onChange={handleChange}/>
                            </div>
                        )}

                        {values.campaignMode === CAMPAIGN_MODE.CAROUSEL && (
                            <div className='campaign-form-section carousel-section'>
                                <label className='campaign-form-label'>Carousel Items ({carouselItems.length}):</label>

                                <div className='carousel-items-list'>
                                    {carouselItems.map((item, index) => (
                                        <div key={item.id} className='carousel-item-preview'>
                                            <img
                                                src={URL.createObjectURL(item.image)}
                                                alt={`Carousel ${index + 1}`}
                                                className='carousel-item-thumb'
                                            />
                                            <div className='carousel-item-info'>
                                                <span className='carousel-item-number'>#{index + 1}</span>
                                                {item.buttonText && <span className='carousel-item-btn-text'>{item.buttonText}</span>}
                                            </div>
                                            <button
                                                type='button'
                                                className='carousel-item-remove'
                                                onClick={() => removeCarouselItem(item.id)}
                                            >
                                                X
                                            </button>
                                        </div>
                                    ))}
                                </div>

                                <div className='carousel-add-item'>
                                    <label className='campaign-form-label'>Add New Carousel Item:</label>
                                    <div className='carousel-add-item-form'>
                                        <div className='carousel-input-group'>
                                            <label>Image:</label>
                                            <input
                                                type="file"
                                                name="carouselImage"
                                                accept="image/jpg, image/jpeg, image/png"
                                                onChange={handleCarouselItemChange}
                                            />
                                        </div>
                                        <div className='carousel-input-group'>
                                            <label>Button Text:</label>
                                            <input
                                                type="text"
                                                name="buttonText"
                                                placeholder="e.g. Learn More"
                                                value={currentCarouselItem.buttonText}
                                                onChange={handleCarouselItemChange}
                                                className='campaign-form-input'
                                            />
                                        </div>
                                        <div className='carousel-input-group'>
                                            <label>Button Link:</label>
                                            <input
                                                type="text"
                                                name="buttonLink"
                                                placeholder="https://..."
                                                value={currentCarouselItem.buttonLink}
                                                onChange={handleCarouselItemChange}
                                                className='campaign-form-input'
                                            />
                                        </div>
                                        <button
                                            type='button'
                                            className='carousel-add-btn'
                                            onClick={addCarouselItem}
                                            disabled={!currentCarouselItem.image}
                                        >
                                            + Add Item
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className='campaign-form-section-date-pickers-wrapper'>
                            <div className='campaign-form-section'>
                                <div className='date-picker-section'>
                                    <label className='campaign-form-label' htmlFor="">Valid from:</label>
                                    <div className='date-input-wrapper'>
                                        <input className='date-input'
                                               name='validFrom'
                                               type="text"
                                               autoComplete='off'
                                               disabled
                                               value={Moment.tz(values.validFrom, 'Europe/Belgrade').format('DD.MM.YYYY')}/>
                                        <span className='cancel-date'
                                              onClick={() => handleDateDismiss(INPUT_DATE_NAME.VALID_FROM)}>X</span>
                                    </div>
                                    <div className={'campaign-form-calendar'}>
                                        <Calendar onChange={handleSelectedDateValidFrom}
                                                  minDate={new Date()}/>
                                    </div>
                                </div>
                            </div>
                            <div className='campaign-form-section'>
                                <div className='date-picker-section'>
                                    <label className='campaign-form-label' htmlFor="">Valid To:</label>
                                    <div className='date-input-wrapper'>
                                        <input className='date-input'
                                               name='validTo'
                                               type="text"
                                               autoComplete='off'
                                               disabled
                                               value={Moment.tz(values.validTo, 'Europe/Belgrade').format('DD.MM.YYYY')}/>
                                        <span className='cancel-date'
                                              onClick={() => handleDateDismiss(INPUT_DATE_NAME.VALID_TO)}>X</span>
                                    </div>
                                    <div className={'campaign-form-calendar'}>
                                        <Calendar onChange={handleSelectedDateValidTo}
                                                  minDate={values.validFrom ? values.validFrom : new Date()}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='campaign-form-section'>
                            <p className={'error-message'}>{errors.campaignsList}</p>
                            <label className='campaign-form-label' htmlFor="">List of UIDs:</label>
                            <textarea className={`campaign-form-textarea ${errors.campaignsList && 'error-input'}`}
                                      name='campaignsList'
                                      value={values.campaignsList.toString()}
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      placeholder={'List of UIDs comma separated, no space in between. E.g. Uid,Uid,Uid'}
                                      cols="60"
                                      rows="5"/>

                        </div>
                        <div className='campaign-form-section'>
                            <input id='usedOnlyOnce'
                                   className='campaign-form-checkbox'
                                   name='usedOnlyOnce'
                                   type="checkbox"
                                   defaultChecked={values.usedOnlyOnce}
                                   value={values.usedOnlyOnce}
                                   onChange={handleChange}/>
                            <label className='campaign-form-label' htmlFor="usedOnlyOnce">Valid for only once use:</label>
                        </div>
                        <div className='campaign-form-section campaign-form-section-bottom'>
                            <div className=''>
                                <input className='campaigns-send-button' type="submit"
                                       value="Send Campaign"/>
                                {loading && <Spinner animation="border" variant="primary" />}
                            </div>
                            <div className='campaign-number-of-target'>
                                <label>Targeted number of users</label>
                                <div style={{textAlign: 'center'}}>
                                    <span>{countOfIds}</span> / <span>{visits.length}</span>
                                </div>

                            </div>
                        </div>

                    </form>
                </div>
            </div>
            <CampaignsPreviewPhone
                newCampaignData={values}
                companyData={companyData}
                companyLogoURL={companyLogoURL}
                carouselItems={carouselItems}
            />
        </div>
    )
};

export default CreateCustomCampaign;


